import ModalApprove from './modal-approve.component'

export default ModalApprove